import styled from 'styled-components';

export const LargeDeliverySubtitle = styled.p`
  margin: 8px 0 0;
  text-align: center;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  color: #8a94a6;
`;

export const LargeDeliverySection = styled.div`
  margin-top: 8px;
`;

export const LargeDeliveryRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 10px 0;
`;

export const LargeDeliveryLabel = styled.span`
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  color: #8a94a6;
`;

export const LargeDeliveryValue = styled.span`
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.4;
  color: #2f3d48;
  text-align: right;
`;

export const LargeDeliveryDivider = styled.div`
  height: 1px;
  background: #eceff3;
  margin: 8px 0 4px;
`;

export const LargeDeliveryControlLabel = styled.span`
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.4;
  color: #2f3d48;
`;

export const LargeDeliveryStepper = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 12px;
  background: #f7f7fa;
  border: 1px solid #d5d8de;
  border-radius: 24px;
  padding: 6px 10px;
`;

export const LargeDeliveryStepperButton = styled.button`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 1px solid #d5d8de;
  background: #fff;
  color: #2f3d48;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;

  &:disabled {
    opacity: 0.4;
    cursor: default;
  }
`;

export const LargeDeliveryStepperValue = styled.span`
  min-width: 16px;
  text-align: center;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: #2f3d48;
`;

export const LargeDeliveryTipNote = styled.p`
  margin: 0 0 8px;
  font-family: 'Poppins', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.4;
  color: #8a94a6;

  span {
    color: #ff2d38;
  }
`;

export const LargeDeliveryTipSelect = styled.div`
  min-width: 120px;
  max-width: 140px;

  .MuiFormControl-root {
    width: 100%;
    min-height: 40px;
    padding: 0 8px;
  }

  .MuiSelect-select.MuiSelect-select {
    padding: 10px 28px 10px 12px;
    font-weight: 500;
  }
`;

export const LargeDeliveryTipAmount = styled.div`
  min-width: 120px;
  max-width: 160px;
`;

export const LargeDeliveryTotalRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: 12px;
`;

export const LargeDeliveryTotalLabel = styled.span`
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  font-weight: 700;
  color: #2f3d48;
`;

export const LargeDeliveryTotalValue = styled.span`
  font-family: 'Poppins', sans-serif;
  font-size: 20px;
  font-weight: 700;
  color: #2f3d48;
`;

export const LargeDeliveryLoading = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 180px;
  padding: 24px 0;
`;
